module.exports = {
    LoadTargets: "NEXUSDATA.TARGETLOAD",
    LoadedTargets: "NEXUSDATA.TARGETLOADED",
    LoadTargetsErrored: "NEXUSDATA.TARGETLOADERRORED",
    TargetSelected: "NEXUSDATA.TARGETSELECTED",
};


// WEBPACK FOOTER //
// ./src/actions/metadata/NexusDataActions.js